import { Routes } from '@angular/router';

import { SocialComponent } from './social.component';

export const socialRoutes: Routes = [
  { path: 'social', component: SocialComponent },
];



// WEBPACK FOOTER //
// ./src/app/social/social.routes.ts